export const SequelFontFamily = 'Sequel';
export const MontserratFontFamily = 'Montserrat';
